import { DOCUMENT } from '@angular/common';
import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';

import { environment } from '../../../environments/environment';
import { getDomainRedirect } from '../config/domain-routing';

export const domainGuard: CanMatchFn = () => {
  const location = inject(DOCUMENT).location;
  const router = inject(Router);
  const path = router.getCurrentNavigation()?.initialUrl.toString() ?? location.pathname;
  const redirect = getDomainRedirect(new URL(path, location.origin), environment.appUrl, environment.landingUrl);
  if (!redirect) return true;
  if (redirect.origin === location.origin) {
    return router.parseUrl(`${redirect.pathname}${redirect.search}${redirect.hash}`);
  }
  location.replace(redirect.href);
  return false;
};
